import { ResponseResult } from '@amzn/gbsa-helios-typescript-client';

// Optional props include explicit `| undefined` so SDK-derived and
// component-level question types stay assignable under
// exactOptionalPropertyTypes.
interface QuestionWithResponse {
  responseDetails?:
    | {
        mainQuestionResponse?:
          | {
              responseResult?: string | undefined;
            }
          | undefined;
      }
    | undefined;
}

export interface QuestionStats {
  passCount: number;
  failCount: number;
  naCount: number;
}

export function computeQuestionStats(questions: QuestionWithResponse[]): QuestionStats {
  let passCount = 0;
  let failCount = 0;
  let naCount = 0;

  for (const q of questions) {
    const result = q.responseDetails?.mainQuestionResponse?.responseResult;
    if (result === ResponseResult.PASS) passCount++;
    else if (result === ResponseResult.FAIL) failCount++;
    else if (result === ResponseResult.NA) naCount++;
  }

  return { passCount, failCount, naCount };
}
